import {fieldValue, nextId} from "../common/NamaCommon";
import * as ts from '../common/Translator'
import {BooleanFieldWidget} from "../widgets/BooleanFieldWidget";
import {NamaGridLineEditor} from "./NamaGridLineEditor";

export function booleanColumnEditor(fieldMetadata, trimmedFieldId, grid) {
    return (container, options) => {
        if (container instanceof NamaGridLineEditor) {
            let widget = new BooleanFieldWidget({owner: grid, fieldMetadata, cellOptions: options});
            widget.inputName = options.field;
            grid.afterAddingToGridAction(widget, options, trimmedFieldId, container);
        } else {
            let id = nextId();
            let isChecked = fieldValue(options.model, trimmedFieldId);
            let checkBox = $(`<input class='k-checkbox' id=${id} type='checkbox'  data-bind='checked:${trimmedFieldId}'>`);
            checkBox.on("click", (e) => {
                let checked = checkBox.prop("checked");
                grid.onDataChanged(fieldMetadata.fieldId, checked, options);
            });
            checkBox.appendTo(container);
            let label = $('<label class="k-checkbox-label" for="' + id + '">​</label>');
            label.appendTo(container);
        }
    }
}

export function booleanTemplate(fieldId, trimmedFieldId) {

    return (dataItem) => {
        let value = fieldValue(dataItem, trimmedFieldId);
        if (value === undefined || value === false)
            value = "_false";
        else
            value = "_true";
        return ts.translateId(value);
    }
}